import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/courses/business-and-accountancy/basic-business-accountancy_/lessons/",
)({
  beforeLoad: () => {
    throw redirect({
      to: "/courses/business-and-accountancy/basic-business-accountancy/lessons/$lessonId",
      params: { lessonId: "1.1" },
    });
  },
});
